export const supportsAnchorPositioning = 'anchorName' in document.documentElement.style;
